import { defineMessages, useIntl } from 'react-intl';

import { switchcase } from '@garnish/core';

import type { DeliveryPreferenceType } from '@sg/graphql-schema';

export const usePreferencesText = (type: DeliveryPreferenceType): string => {
  const { formatMessage } = useIntl();

  return switchcase({
    LEAVE_AT_DOOR: formatMessage(messages.leaveAtDoor),
    DOOR: formatMessage(messages.meetAtDoor),
    CURBSIDE: formatMessage(messages.meetOutside),
  })(formatMessage(messages.leaveAtDoor))(type);
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  leaveAtDoor: {
    defaultMessage: 'Leave at door',
    description: 'Order Status | Delivery Preference | Leave at door',
  },
  meetAtDoor: {
    defaultMessage: 'Meet at door',
    description: 'Order Status | Delivery Preference | Meet at door',
  },
  meetOutside: {
    defaultMessage: 'Meet outside',
    description: 'Order Status | Delivery Preference | Meet outside',
  },
});
